import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class Hero {
    constructor(el, app) {
        this.el = el;
        this.app = app; // Keep reference to App

        this.options = {
            start: 'top 75%',
            end: 'top 70%',
            duration: 0.6,
            opacityFrom: 0,
            opacityTo: 1,
            topFrom: '40px',
            topTo: '0px',
        };

        this.init();
    }

    init() {
        this.setOptions();

        this.playAnim(this.el);
    }

    setOptions() {}

    playAnim(el) {
        let heroTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: el,
                start: this.options.start,
                end: this.options.end,
            },
        });

        heroTimeline.add('animateHERO');

        let img = el.querySelector('.hero__image');
        if (img) {
            heroTimeline.fromTo(
                img,
                {
                    opacity: this.options.opacityFrom,
                    top: this.options.topFrom,
                },
                {
                    duration: this.options.duration,
                    opacity: this.options.opacityTo,
                    top: this.options.topTo,
                },
                'animateHERO'
            );
        }
    }
}
